// extracted by mini-css-extract-plugin
module.exports = {"form":"_3I0duiAU","formTitle":"_2S5wYcDP"};